exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "input, button {\n  display: inline-block;\n  margin-top:3px\n}\n\ninput.regexp {\n  width: 10em;\n}\n\ninput.weight {\n  margin-left: 1ex;\n  width: 3em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/criterion-item-box/criterion-item-box.component.css
// module id = 381
// module chunks = 0